import {
  createReusableStylesheet,
  tcwebReusableStylesheet,
  type ReusableStylesheet,
} from '@trimble/stylesheets';
import overrideStyles from '../override.css?inline';
import styles from '../styles.css?inline';

export const layerListPanelStylesheet = createReusableStylesheet(
  'layer-list-panel:styles',
  styles
);
export const layerListPanelOverrideStylesheet = createReusableStylesheet(
  'layer-list-panel:override-styles',
  overrideStyles
);

export const layerListPanelStylesheets: readonly ReusableStylesheet[] = [
  tcwebReusableStylesheet,
  layerListPanelStylesheet,
  layerListPanelOverrideStylesheet,
];
